import type { SVGProps, FC } from "react"

const RoofMount: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59.225"
    height="55.256"
    viewBox="0 0 59.225 55.256"
    fill="currentColor"
    {...props}
  >
    <g
      id="solar-panel_4_"
      data-name="solar-panel (4)"
      transform="translate(0 -17.159)"
    >
      <path
        id="Path_707"
        data-name="Path 707"
        d="M108.479,389.214a1.454,1.454,0,0,0,1.452-1.452v-3.036a1.454,1.454,0,0,0-1.452-1.452h-4.486a1.454,1.454,0,0,0-1.452,1.452v3.036a1.454,1.454,0,0,0,1.452,1.452Zm-4.2-4.205H108.2v2.47h-3.921Z"
        transform="translate(-90.68 -323.765)"
      />
      <path
        id="Path_708"
        data-name="Path 708"
        d="M351.519,389.214a1.454,1.454,0,0,0,1.452-1.452v-3.036a1.454,1.454,0,0,0-1.452-1.452h-4.486a1.454,1.454,0,0,0-1.452,1.452v3.036a1.454,1.454,0,0,0,1.452,1.452Zm-4.2-4.205h3.921v2.47h-3.921Z"
        transform="translate(-305.607 -323.765)"
      />
      <path
        id="Path_709"
        data-name="Path 709"
        d="M59.086,170.053l-1.416-3.115a.868.868,0,0,0-1.58.718l1.292,2.843H1.844l3.809-8.378a.3.3,0,0,1,.274-.177H6.988v2.186a1.454,1.454,0,0,0,1.452,1.452H21.459a1.454,1.454,0,0,0,1.452-1.452v-2.186h3.456l-1.294,2.892a1.381,1.381,0,0,0,1.261,1.945H51.229a1.381,1.381,0,0,0,1.26-1.945L51.2,161.943h2.1a.3.3,0,0,1,.274.178l.814,1.789a.868.868,0,1,0,1.579-.719l-.814-1.789a2.041,2.041,0,0,0-1.854-1.195H50.42l-2.307-5.157a1.28,1.28,0,0,0-1.167-.756H30.617a1.28,1.28,0,0,0-1.167.756l-2.307,5.157H22.911V157.1l1.275.749a.868.868,0,1,0,.879-1.5l-9.676-5.684a.867.867,0,0,0-.879,0l-9.677,5.684a.868.868,0,1,0,.879,1.5l1.275-.749v3.113H5.927A2.04,2.04,0,0,0,4.073,161.4L.14,170.053a1.542,1.542,0,0,0,1.4,2.181H4.392v8.281a.868.868,0,1,0,1.735,0v-8.281H53.1v16.4H35.145V176.4a1.337,1.337,0,0,0-1.335-1.335H25.416a1.337,1.337,0,0,0-1.335,1.335v12.238H6.127v-4.075a.868.868,0,1,0-1.735,0v4.591a1.22,1.22,0,0,0,1.218,1.218h48a1.22,1.22,0,0,0,1.218-1.218v-16.92h2.848a1.542,1.542,0,0,0,1.4-2.181ZM40.844,156.03l.276,1.849H36.444l.276-1.849Zm.534,3.584.276,1.848H35.909l.276-1.848Zm7.7,1.848H43.408l-.276-1.848h5.12ZM41.913,163.2l.276,1.848H35.375l.276-1.848Zm-7.758-1.735H28.484l.827-1.848h5.12ZM27.708,163.2H33.9l-.276,1.848h-6.74Zm16.235,1.848-.276-1.848h6.189l.827,1.848Zm3.534-7.166h-4.6L42.6,156.03H46.65ZM30.913,156.03h4.052l-.276,1.849h-4.6Zm-14.357,7.816H13.342v-3.27a1.607,1.607,0,0,1,3.214,0v3.27ZM14.95,152.419l6.227,3.657v7.77H18.291v-3.27a3.342,3.342,0,0,0-6.684,0v3.27H8.723v-7.77ZM25.816,176.8H33.41v11.839H25.816Z"
        transform="translate(0 -117.958)"
      />
      <path
        id="Path_710"
        data-name="Path 710"
        d="M295.7,47.345a4.594,4.594,0,0,0,3.248,5.626,4.619,4.619,0,0,0,1.2.158,4.595,4.595,0,1,0-4.444-5.784Zm1.676.449a2.862,2.862,0,0,1,2.756-2.12,2.873,2.873,0,0,1,.745.1,2.858,2.858,0,1,1-3.5,2.021Z"
        transform="translate(-261.359 -23.682)"
      />
      <path
        id="Path_711"
        data-name="Path 711"
        d="M294.2,19.126a.868.868,0,1,0,1.5-.868l-.384-.666a.868.868,0,1,0-1.5.868Z"
        transform="translate(-259.73)"
      />
      <path
        id="Path_712"
        data-name="Path 712"
        d="M260.5,77.9h.769a.868.868,0,0,0,0-1.735H260.5a.868.868,0,0,0,0,1.735Z"
        transform="translate(-229.604 -52.183)"
      />
      <path
        id="Path_713"
        data-name="Path 713"
        d="M294.137,131.7a.867.867,0,0,0,1.185-.318l.384-.666a.868.868,0,1,0-1.5-.868l-.384.666A.867.867,0,0,0,294.137,131.7Z"
        transform="translate(-259.73 -99.274)"
      />
      <path
        id="Path_714"
        data-name="Path 714"
        d="M360.137,129.853a.867.867,0,1,0-1.5.867l.384.666a.867.867,0,1,0,1.5-.867Z"
        transform="translate(-317.048 -99.275)"
      />
      <path
        id="Path_715"
        data-name="Path 715"
        d="M390.132,77.9h.769a.868.868,0,1,0,0-1.735h-.769a.868.868,0,1,0,0,1.735Z"
        transform="translate(-344.237 -52.183)"
      />
      <path
        id="Path_716"
        data-name="Path 716"
        d="M358.952,19.444a.867.867,0,0,0,1.185-.318l.384-.666a.867.867,0,1,0-1.5-.867l-.384.666A.868.868,0,0,0,358.952,19.444Z"
        transform="translate(-317.047 0)"
      />
    </g>
  </svg>
)

export default RoofMount
